import { Button, Col, Row, DropdownButton, Form, Badge } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { RootState } from "../redux/store";
import { useEffect } from "react";
import { getDepartments } from "../redux/slices/Departments";
import { getSuppliers } from "../redux/slices/Suppliers";
import { getStockGroups } from "../redux/slices/StockGroups";
import { getSubDepartments, updateSubDepartmentField } from "../redux/slices/SubDepartment";
import { useState } from "react";
import { FormInput } from "../components";
import { getManufacturers } from "redux/slices/ManagedManufacturers";

type CustomFilterProps = {
    data: {
        departmentIdFilter?: number,
        supplierCodesFilter?: string,
        subdepartmentIdFilter?: number,
        supplierIdFilter?: number,
        manufacturerIdFilter?: number,
        stockGroupIdFilter?: number,
        activeFilter?: any,
        ethicalFilter?: any,
        scheduleFilter?: string,
        pbsFilter?: number
        createDateBeforeFilter?: string,
        createDateAfterFilter?: string,
    }
    systemStock?: boolean
    handleChange: (option:string, optionValue:any) => void,
    applyFilters: () => void,
    clearFilters: () => void,
};

export default function CustomFilter({
    data,
    systemStock,    
    handleChange,
    applyFilters,
    clearFilters
}: CustomFilterProps) {
    const { departmentIdFilter, supplierCodesFilter, subdepartmentIdFilter, supplierIdFilter, manufacturerIdFilter, stockGroupIdFilter, activeFilter, ethicalFilter, scheduleFilter, pbsFilter, createDateBeforeFilter, createDateAfterFilter } = data;
    const dispatch = useAppDispatch();
    const [displayMenu, setDisplayMenu] = useState(false);
    const suppliers = useAppSelector((state: RootState) => state.suppliers);
    const departments = useAppSelector((state: RootState) => state.department);
    const subDepartments = useAppSelector((state: RootState) => state.subDepartment);
    const manufacturers = useAppSelector((state: RootState) => state.managedManufacturers);
    const stockGroups = useAppSelector((state: RootState) => state.stockGroups);
    const [filterCounter, setFilterCounter] = useState(0);

    useEffect(() => {
        if (departmentIdFilter !== undefined) dispatch(getDepartments());
        if (supplierIdFilter !== undefined) dispatch(getSuppliers());
        if (stockGroupIdFilter !== undefined) dispatch(getStockGroups());
        if (manufacturerIdFilter !== undefined) dispatch(getManufacturers());
    }, []);

    useEffect(() => {
        updateFilterCounter();
    }, [data]);

    function updateFilterCounter() {
        let counter = 0;
        if(!systemStock){
            if (departmentIdFilter !== undefined && departmentIdFilter !== 0) counter++;
            if (subdepartmentIdFilter !== undefined && subdepartmentIdFilter !== 0) counter++;
            if (supplierIdFilter !== undefined && supplierIdFilter !== 0) counter++;
            if (manufacturerIdFilter !== undefined && manufacturerIdFilter !== 0) counter++;
            if (stockGroupIdFilter !== undefined && stockGroupIdFilter !== 0) counter++;
            if (activeFilter !== false && activeFilter !== 0 ) counter++;    
        }
        if (supplierCodesFilter !== undefined && supplierCodesFilter !== "") counter++;
        if (createDateBeforeFilter !== undefined && createDateBeforeFilter !== "") counter++;
        if (createDateAfterFilter !== undefined && createDateAfterFilter !== "") counter++;
        if (ethicalFilter !== false && ethicalFilter !== 0 ) counter++;
        if (scheduleFilter !== undefined && scheduleFilter !== "0" ) counter++;
        if (pbsFilter !== undefined && pbsFilter !== 0 ) counter++;
        setFilterCounter(counter);
    }

    useEffect(() => {
        if (departmentIdFilter !== 0) {
            dispatch(getSubDepartments(departmentIdFilter as number));
        }
    }, [departmentIdFilter, subdepartmentIdFilter, supplierIdFilter, manufacturerIdFilter, stockGroupIdFilter, activeFilter, ethicalFilter, scheduleFilter, pbsFilter, supplierCodesFilter, createDateBeforeFilter, createDateAfterFilter]);

    const Counter = ( ) => {
        return <>
            Filter { filterCounter !== 0 && <Badge className="me-1 badge-info-lighten counter-badge" >{filterCounter}</Badge> }
        </>;
    }

    return (
        <DropdownButton
            show={displayMenu}
            autoClose="outside"
            variant="light"
            title={<Counter /> }
            className="btn-icon me-1 d-inline-flex"
            onToggle={() => setDisplayMenu(!displayMenu)}
        >
            {supplierIdFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Supplier</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={supplierIdFilter}
                                onChange={(e) => handleChange("supplierIdFilter", parseInt(e.target.value))}>
                                <option value="0"> </option>
                                {suppliers.table.map((supplier: any, index: any) => {
                                    return <option key={index} value={supplier.id}>{supplier.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {systemStock &&
                <Row className="m-2">
                    <Col xs={5}>Supplier</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={supplierCodesFilter}
                                onChange={(e) => handleChange("supplierCodesFilter", e.target.value)}>
                                <option value="0"> </option>
                                {suppliers.table.map((supplier: any, index: any) => {
                                    if (supplier.systemCode) return <option key={index} value={supplier.systemCode}>{supplier.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {departmentIdFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Department</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={departmentIdFilter}
                                onChange={(e) => {
                                    handleChange("departmentIdFilter", parseInt(e.target.value));
                                    if (parseInt(e.target.value) === 0)
                                        handleChange("subdepartmentIdFilter", parseInt(e.target.value));
                                }}>
                                <option value="0"> </option>
                                {departments.table.map((department: any, index: any) => {
                                    return <option key={index} value={department.id}>{department.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {subdepartmentIdFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Sub Department</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={subdepartmentIdFilter}
                                onChange={(e) => handleChange("subdepartmentIdFilter", parseInt(e.target.value))}>
                                <option value="0"> </option>
                                {departmentIdFilter !== 0 && subDepartments.table.map((subDepartment: any, index: any) => {
                                    return <option key={index} value={subDepartment.id}>{subDepartment.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {manufacturerIdFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Manufacturer</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={manufacturerIdFilter}
                                onChange={(e) => handleChange("manufacturerIdFilter", parseInt(e.target.value))}>
                                <option value="0"> </option>
                                {manufacturers.table.map((manufacturer: any, index: any) => {
                                    return <option key={index} value={manufacturer.id}>{manufacturer.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {stockGroupIdFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Stock Group</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={stockGroupIdFilter}
                                onChange={(e) => handleChange("stockGroupIdFilter", parseInt(e.target.value))}>
                                <option value="0"> </option>
                                {stockGroups.table.map((stockGroup: any, index: any) => {
                                    return <option key={index} value={stockGroup.id}>{stockGroup.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {activeFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Active</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={activeFilter}
                                onChange={(e) => handleChange("activeFilter", parseInt(e.target.value))}>
                                <option value="0"> </option>
                                <option value="1">Yes</option>
                                <option value="2">No</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {ethicalFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Ethical</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select"
                                value={ethicalFilter}
                                onChange={(e) => handleChange("ethicalFilter", parseInt(e.target.value))}>
                                <option value="0"> </option>
                                <option value="1">Yes</option>
                                <option value="2">No</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {scheduleFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>Schedule</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={scheduleFilter}
                                onChange={(e) => handleChange("scheduleFilter", e.target.value)}>
                                <option value="0"> </option>
                                <option value="U">U</option>
                                <option value="S2">S2</option>
                                <option value="S3">S3</option>
                                <option value="S4">S4</option>
                                <option value="S8">S8</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            {pbsFilter !== undefined &&
                <Row className="m-2">
                    <Col xs={5}>PBS</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select" value={pbsFilter}
                                onChange={(e) => handleChange("pbsFilter", parseInt(e.target.value))}>
                                <option value="0"> </option>
                                <option value="1">Yes</option>
                                <option value="2">No</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>}
            { systemStock && <>
                <Row className="m-2">
                    <Col xs={5}>Created Before</Col>
                    <Col xs={7}>
                        <Form.Group>
                            <FormInput
                                type="date"
                                name="date"
                                key="date"
                                value={createDateBeforeFilter}
                                onChange={(e) => handleChange("createDateBeforeFilter", e.target.value)}
                            />
                        </Form.Group>
                    </Col>  
                </Row>
                <Row  className="m-2">
                    <Col xs={5}>Created After</Col>
                    <Col xs={7}>
                        <Form.Group>
                        <FormInput
                                type="date"
                                name="date"
                                id="date"
                                key="date"
                                value={createDateAfterFilter}
                                onChange={(e) => handleChange("createDateAfterFilter", e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </>
            }
            <Row className="m-2">
                <Col xs={6}>
                    <Button variant="light" className="btn-icon custom-btn-icon" onClick={clearFilters}>Clear Filters</Button>
                </Col>
                <Col xs={6} className="d-flex flex-row-reverse">
                    <Button variant="primary" className="btn-icon custom-btn-icon" onClick={() => {
                        setDisplayMenu(false);
                        applyFilters();
                    }}>Apply Filters</Button>
                </Col>
            </Row>
        </DropdownButton>
    )
}